var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from 'react';
import { Tooltip } from '@material-ui/core';
import { ComplementaryTherapyOrderInfoBar } from '../EditMedicationModal/MedicationAlertBanner/ComplementaryTherapyOrderInfoBar';
import { white50 } from '../Styles/Colours';
import { StyledDialogButton } from '../Components/Dialog/StyledDialogButton';
import { Button, ButtonMode, ButtonVariant } from '../Components/Button';
import { StyledDialog } from '../Components/Dialog/StyledDialog';
import { StyledDialogContent } from '../Components/Dialog/StyledDialogContent';
import { CloseIcon } from '../Components/Icons';
import styles from './ComplementaryTherapyOrderDialog.module.css';
import { MaskedTextField } from '../Components/MaskedTextField';
import { DecisionSupportWarningAlert } from '../DecisionSupportWarningAlert';
export var ComplementaryTherapyOrderDialog = function (props) {
    var _a;
    var _b = __read(useState((_a = props.freeTextMedicationName) !== null && _a !== void 0 ? _a : ''), 2), freeTextMedicationName = _b[0], setFreeTextMedicationName = _b[1];
    var _c = __read(useState(false), 2), processing = _c[0], setProcessing = _c[1];
    var disableMedicationSelection = function () {
        if (processing)
            return true;
        return (freeTextMedicationName !== null && freeTextMedicationName !== void 0 ? freeTextMedicationName : '').trim() === '';
    };
    var onSubmit = function () { return __awaiter(void 0, void 0, void 0, function () {
        var trimmedFreeText;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (disableMedicationSelection())
                        return [2 /*return*/];
                    trimmedFreeText = (freeTextMedicationName !== null && freeTextMedicationName !== void 0 ? freeTextMedicationName : '').trim();
                    setProcessing(true);
                    if (!(!!props.onSelectFreeTextMedication && trimmedFreeText !== '')) return [3 /*break*/, 2];
                    return [4 /*yield*/, props.onSelectFreeTextMedication(trimmedFreeText)];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2:
                    setProcessing(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var actionButtons = [
        React.createElement(StyledDialogButton, { mode: ButtonMode.solid, variant: ButtonVariant.light, width: 161, key: 'cancel', onClick: props.onCancel, testId: 'navigation-control-cancel' }, "Cancel"),
        React.createElement(StyledDialogButton, { key: 'select', width: 161, onClick: onSubmit, disabled: disableMedicationSelection(), testId: 'navigation-control-select' }, "Select medication")
    ];
    return (React.createElement(StyledDialog, { open: true, size: 'xs', modal: true, testId: 'complementary-therapy', title: 'Complementary therapy', titleBarRight: React.createElement(Tooltip, { title: 'Close' },
            React.createElement(Button, { iconOnly: true, onClick: props.onCancel, noShadowOnHover: true, subtleShadeOnHover: true, testId: 'close-complementary-therapy-dialog' },
                React.createElement(CloseIcon, { size: '20', color: white50, noPadding: true }))), actions: actionButtons, contentComponent: React.createElement(StyledDialogContent, { noPadding: true },
            React.createElement("div", { className: styles.container },
                React.createElement(ComplementaryTherapyOrderInfoBar, null),
                React.createElement("div", { className: styles.decisionSupportWarningAlertContainer },
                    React.createElement(DecisionSupportWarningAlert, { isComplementary: true })),
                React.createElement("div", { className: styles.label },
                    React.createElement(MaskedTextField, { name: 'freeTextMedicationName', label: 'Medication name', testId: 'input-free-text-medication-name', autoFocus: true, fillContainer: true, required: true, value: freeTextMedicationName !== null && freeTextMedicationName !== void 0 ? freeTextMedicationName : '', onChange: function (e) { return setFreeTextMedicationName(e); }, onClear: function () { return setFreeTextMedicationName(''); } })))) }));
};
